/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Hero_PricingInputs */

const en_platform_hero_pricing = /** @type {(inputs: Platform_Hero_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See pricing`)
};

const pl_platform_hero_pricing = /** @type {(inputs: Platform_Hero_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz cennik`)
};

/**
* | output |
* | --- |
* | "See pricing" |
*
* @param {Platform_Hero_PricingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_hero_pricing = /** @type {((inputs?: Platform_Hero_PricingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Hero_PricingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_hero_pricing(inputs)
	return en_platform_hero_pricing(inputs)
});